import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';
import { classNames } from "~/utils/utils";

import "./style.less";

interface ITextFieldLen extends StandardTextFieldProps {
	// max cislo | [min cislo, max cislo]
	lenRange: number | Array<number>;
}

export default function TextFieldLen({
	lenRange,
	...props
}: ITextFieldLen) {
	const isLenArray = lenRange && Array.isArray(lenRange);
	const curLen = (props.value as string).length;
	const helperText = lenRange
		? <>
			<span className="textFieldLen__helperText">
				{ props.helperText }
			</span>
			<span className={classNames(["textFieldLen__helperLen", ...isLenArray ? [curLen >= lenRange[0] ? "green-text-color" : "red-text-color"] : []])}>
				{ curLen } / { isLenArray ? lenRange[1] : lenRange }
			</span>
		</>
		: props.helperText;

	return <TextField
		size="small"
		inputProps={{
			autoComplete: "off",
			...lenRange
				? {
					maxLength: isLenArray ? lenRange[1] : lenRange,
				}
				: {},
		}}
		{ ...props }
		helperText={helperText}
		FormHelperTextProps={{
			classes: {
				root: "textFieldLen__helperTextCont",
			},
		}}
	/>;
}
